import { CardContainer } from "../../../components/Card/CardContainer";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import PageTitleNested from "../../../components/PageTitle/PageTitleNested";
import { Col, Form, Radio, Row, Space } from "antd";
import ProfileImage from "../../../components/ProfileImage/ProfileImage";
import Button from "../../../components/Button/Button";
import Input from "../../../components/Input/Input";
import { defaultPropsFormRequire } from "../../../utility/DefaultProps";
import Select from "../../../components/Select/Select";
import styled from "styled-components";
import color from "../../../resource/color";
import Text from "../../../components/Text/Text";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import { SaleListDatasource } from "../../../datasource/SaleListDatasource";
import { useNavigate } from "react-router-dom";
import { zoneDatasource } from "../../../datasource/ZoneDatasource";
import { useRecoilValue } from "recoil";
import { profileAtom } from "../../../store/ProfileAtom";
import { roleDatasource } from "../../../datasource/RoleDatasource";
import { useLocalStorage } from "../../../hook/useLocalStorage";
import { checkCompany } from "../../../utility/CompanyName";
import UploadImageCropper from "../../../components/UploadFile/UploadImageCropper";
import { teamDatasource } from "../../../datasource/TeamDatasource";
export const Texts = styled.div`
  font-family: "Sarabun";
  font-size: 14px;
  color: ${color.Text1};
  font-weight: 400;
`;
const Top = styled.div``;
const Bottom = styled(Row)`
  border-top: 1px solid ${color.background2};
  padding-top: 20px;
  margin-top: 64px;
`;
export function AddNewSale() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [visible, setVisible] = React.useState(false);
  const [visibleWarning, setVisibleWarning] = React.useState(false);
  const profile = useRecoilValue(profileAtom);
  const [company] = useLocalStorage("profile", null);
  const isInternal = checkCompany(company.company);
  const [file, setFile] = useState<File | null>(null);
  const [selectTeam, setSelectTeam] = useState<string>("ALL");
  const [selectZone, setSelectZone] = useState<string>("ALL");
  const [additionalRoles, setAdditionalRoles] = useState<string>("");
  const [additionalSetting, setAdditionalSetting] = useState<string>("");
  const [zone, setZone] = React.useState<{ label: string; value: string; key: string }[]>([]);
  const [roleList, setRoleList] = React.useState<{ label: string; value: string; key: string }[]>(
    [],
  );
  const [teamId, setTeamId] = useState<string[]>([]);
  const selectedRole = Form.useWatch("role", form);
  const [team, setTeam] = React.useState<{ label: string; value: string; key: string }[]>([]);
  const [roleData, setRoleData] = React.useState<any[]>([]);
  const { setFieldsValue } = form;

  const getTeam = async () => {
    const res = await zoneDatasource.getAllTeam({
      page: 0,
      take: 0,
      company: company?.company,
      status: "ACTIVE",
    });
    const data = res?.data.map((item: any) => {
      return {
        label: item.teamName,
        value: item.teamName,
        key: item.teamId,
      };
    });
    setTeam(data);
    if (additionalRoles === "MULTI_ZONE") {
      getZone(data.map((e) => e.key));
    }
  };
  const getZone = async (id: string | string[]) => {
    const payload = {
      teamId: Array.isArray(id) ? id : [id],
    };
    try {
      await teamDatasource.multiTeamZone(payload).then((res) => {
        const data = res?.map((item: any) => {
          return {
            label: item.zoneName,
            value: item.zoneName,
            key: item.zoneId,
          };
        });
        setZone(data);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const getRoleList = async () => {
    const { data } = await roleDatasource.getAllRoles({
      page: 1,
      take: 100,
      company: profile?.company,
    });
    setRoleData(data?.data || []);

    const newFormat = data.data.map((el: { rolename: string; roleId: string }) => {
      return {
        label: el.rolename,
        value: el.rolename,
        key: el.roleId,
      };
    });
    setRoleList(newFormat);
  };
  const checkDupTelEmail = async (rule, value) => {
    const field = rule?.field;
    if (field === "telephone" && value.length < 10) {
      return;
    }
    const res = await SaleListDatasource.checkTelEmail(
      field === "telephone" ? null : value,
      field === "telephone" ? value : null,
    );
    if (res && res.success) {
      return;
    } else {
      const errorMessage = field === "telephone" ? "เบอร์โทรศัพท์" : "อีเมล";
      throw new Error(`${errorMessage}ถูกใช้แล้วในระบบ`);
    }
  };
  const handleUpload = (uploadedFile: File | null) => {
    setFile(uploadedFile);
  };
  const handleRoleChange = (role) => {
    const isMultiZone = role?.additionalroles === "MULTI_ZONE";
    const resetFields = {
      zone: undefined,
      userStaffToTeam: undefined,
      docType: undefined,
      team: undefined,
      isAllTeam: isMultiZone ? "ALL" : "CUSTOM",
      isAllZone: isMultiZone ? "ALL" : "CUSTOM",
    };

    setSelectTeam(isMultiZone ? "ALL" : "CUSTOM");
    setSelectZone(isMultiZone ? "ALL" : "CUSTOM");
    setFieldsValue(resetFields);

    if (isMultiZone) {
      getTeam();
    }
  };
  useEffect(() => {
    const role = roleData?.find((item) => item.rolename === selectedRole);
    setAdditionalSetting(role?.additionalSetting || null);
    setAdditionalRoles(role?.additionalroles || null);
    handleRoleChange(role);
  }, [selectedRole, roleData]);

  useEffect(() => {
    getRoleList();
    getTeam();
  }, [additionalRoles]);

  const getUserStaffToTeam = (
    additionalRoles: string,
    selectTeam: string,
    team?: { key: string }[],
    teamId?: string[],
  ) => {
    if (additionalRoles === "MULTI_ZONE" && selectTeam === "ALL" && Array.isArray(team)) {
      return team.map((t) => ({ teamId: t.key }));
    }

    if ((additionalRoles === "MULTI_ZONE" || additionalRoles === "SINGLE_ZONE") && teamId) {
      const ids = Array.isArray(teamId) ? teamId : [teamId];
      return ids.map((id) => ({ teamId: id }));
    }

    return [];
  };
  const userStaffToTeam = getUserStaffToTeam(additionalRoles, selectTeam, team, teamId);

  const onFinish = async (values: any) => {
    const { team, ...restValues } = values;

    const zoneValues =
      additionalRoles === "MULTI_ZONE" && selectZone === "ALL"
        ? zone.map((val) => val.value)
        : values.zone;

    const zoneString = Array.isArray(zoneValues)
      ? zoneValues.join(",")
      : typeof zoneValues === "string"
        ? zoneValues
        : "";

    const updatedValues = {
      ...restValues,
      zone: zoneString,
      company: profile?.company,
      status: "ACTIVE",
      isAllTeam: selectTeam,
      isAllZone: selectZone,
      userStaffToTeam: userStaffToTeam || [],
    };
    console.log(updatedValues);
    Swal.fire({
      title: "บันทึกข้อมูลสำเร็จ",
      text: `ลิ้งยืนยันตัวตนผู้ใช้ถูกส่งไปอีเมลผู้ใช้งาน ${values?.email} เรียบร้อยแล้ว กรุณาแจ้งผู้ใช้งาน เพื่อดำเนินการยืนยันตัวตนผู้ใช้งานในอีเมล และกำหนดรหัสผ่านสำหรับเข้าสู่ระบบ`,
      width: 360,
      icon: "success",
      customClass: {
        title: "custom-title",
      },
      timer: 3000,
      showConfirmButton: false,
    }).then(async () => {
      try {
        setLoading(true);
        const res = await SaleListDatasource.createNewSaleStaff(updatedValues);
        if (res && res.success) {
          const userStaffId = res.responseData.userStaffId;
          if (file) {
            const uploadRes = await SaleListDatasource.uploadSignImage(userStaffId, file);
            if (uploadRes && uploadRes.success) {
              setLoading(false);
              navigate("/UserPage/SaleManagementPage?status=wait_approve");
            } else {
              Swal.fire({
                title: uploadRes.userMessage || "Error uploading file.",
                text: "",
                width: 250,
                icon: "error",
                customClass: {
                  title: "custom-title",
                },
                showConfirmButton: false,
              });
            }
          }
          setLoading(false);
          navigate("/UserPage/SaleManagementPage?status=wait_approve");
        } else {
          Swal.fire({
            title: res.userMessage,
            text: "",
            width: 250,
            icon: "error",
            customClass: {
              title: "custom-title",
            },
            showConfirmButton: false,
          }).then(() => {
            setLoading(false);
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    });
  };

  return (
    <CardContainer>
      <Form
        {...defaultPropsFormRequire}
        form={form}
        onFinish={onFinish}
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <Top>
          <PageTitleNested
            title='เพิ่มรายชื่อผู้ใช้งาน'
            onBack={() => {
              const isHaveValue = Object.values(form.getFieldsValue()).some((item) => item);
              if (isHaveValue) {
                setVisibleWarning(true);
              } else {
                navigate(-1);
              }
            }}
          />
          <Row>
            <Form.Item name='profileImage'>
              <ProfileImage />
            </Form.Item>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name='firstname'
                label='ชื่อ'
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกชื่อ",
                  },
                ]}
              >
                <Input placeholder='ระบุชื่อ' autoComplete='off' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name='lastname'
                label='นามสกุล'
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกนามสกุล",
                  },
                ]}
              >
                <Input placeholder='ระบุนามสกุล' autoComplete='off' />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name='nickname' label='ชื่อเล่น'>
                <Input placeholder='ระบุชื่อเล่น' autoComplete='off' />
              </Form.Item>
            </Col>
            {isInternal && (
              <Col span={12}>
                <Form.Item name='userNav' label='ชื่อผู้ใช้ Navision'>
                  <Input placeholder='ระบุชื่อผู้ใช้' autoComplete='off' />
                </Form.Item>
              </Col>
            )}
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name='telephone'
                label='เบอร์โทรศัพท์'
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกเบอร์โทรศัพท์",
                  },
                  {
                    pattern: /^[0-9]*$/,
                    message: "กรุณากรอกเบอร์โทรศัพท์เป็นตัวเลขเท่านั้น",
                  },
                  {
                    min: 10,
                    message: "กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก",
                  },
                  {
                    validator: checkDupTelEmail,
                  },
                ]}
              >
                <Input placeholder='ระบุเบอร์โทรศัพท์' maxLength={10} autoComplete='off' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name='email'
                label='อีเมล'
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกอีเมล",
                  },
                  {
                    type: "email",
                    message: "กรุณากรอกอีเมลให้ถูกต้อง",
                  },
                  {
                    validator: checkDupTelEmail,
                  },
                ]}
              >
                <Input
                  autoComplete='off'
                  placeholder={`${
                    profile?.company?.includes("MGT")
                      ? "ระบุอีเมล"
                      : "ตัวอย่าง iconkaset.i@iconkaset.com"
                  }`}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={additionalSetting === "NAV_DOC" ? 12 : 24}>
              <Form.Item
                name='role'
                label='บทบาท'
                rules={[
                  {
                    required: true,
                    message: "กรุณาเลือกบทบาท",
                  },
                ]}
              >
                <Select
                  style={{ marginBottom: 10 }}
                  data={roleList}
                  placeholder='เลือกบทบาท'
                  onChange={(selectedRole) => handleRoleChange(selectedRole)}
                />
              </Form.Item>
            </Col>
            <Form.Item
              noStyle
              shouldUpdate={(prev, current) => {
                return prev.role !== current.role;
              }}
            >
              {({ getFieldValue }) => {
                return (
                  <>
                    {additionalSetting === "NAV_DOC" && (
                      <Col span={12}>
                        <Form.Item label='ประเภทเอกสาร Navision' name={"docType"}>
                          <Select
                            data={[
                              {
                                label: "SO (Sales Order CO-Sale)",
                                value: "Co-Sales",
                                key: "Co-Sales",
                              },
                              {
                                label: "SP (Sales Order Inventory)",
                                value: "Inventory",
                                key: "Inventory",
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    )}
                  </>
                );
              }}
            </Form.Item>
          </Row>
          {additionalRoles === "SINGLE_ZONE" && (
            <>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name='userStaffToTeam'
                    label='ทีม'
                    rules={[
                      {
                        required: true,
                        message: "กรุณาเลือกทีม",
                      },
                    ]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      placeholder='ระบุทีม'
                      data={team}
                      onChange={(values) => {
                        const selectedTeamIds = team
                          .filter((item) => values.includes(item.value))
                          .map((item) => item.key);
                        setTeamId(selectedTeamIds);
                        getZone(selectedTeamIds);
                        form.setFieldValue("zone", undefined);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name='zone'
                    label='เขต'
                    rules={[
                      {
                        required: true,
                        message: "กรุณาเลือกเขต",
                      },
                    ]}
                  >
                    <Select style={{ marginBottom: 8 }} data={zone} placeholder='ระบุเขต' />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          {additionalRoles === "MULTI_ZONE" && (
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name='isAllTeam'
                  label='ทีม'
                  initialValue='ALL'
                  rules={[{ required: true, message: "กรุณาเลือกทีม" }]}
                >
                  <Row gutter={8} align='middle'>
                    <Col span={8}>
                      <Radio.Group
                        value={selectTeam}
                        onChange={(e) => {
                          setSelectTeam(e.target.value);
                          if (e.target.value === "ALL") {
                            form.setFieldValue("team", undefined);
                          }
                        }}
                        style={{ width: "100%" }}
                      >
                        <Space>
                          <Radio value='ALL'>
                            <Texts>ทั้งหมด</Texts>
                          </Radio>
                          <Radio value='CUSTOM'>
                            <Texts>เลือกทีม</Texts>
                          </Radio>
                        </Space>
                      </Radio.Group>
                    </Col>

                    <Col span={16}>
                      <Form.Item
                        name='team'
                        noStyle
                        rules={[
                          {
                            required: selectTeam === "CUSTOM",
                            message: "กรุณาเลือกทีม",
                          },
                        ]}
                      >
                        <Select
                          disabled={selectTeam !== "CUSTOM"}
                          placeholder='ระบุทีม'
                          style={{ width: "100%" }}
                          mode='multiple'
                          data={team}
                          onChange={(values) => {
                            const selectedTeamIds = team
                              .filter((item) => values.includes(item.value))
                              .map((item) => item.key);
                            setTeamId(selectedTeamIds);
                            getZone(selectedTeamIds);
                            form.setFieldValue("zone", undefined);
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name='isAllZone'
                  label='เขต'
                  initialValue='ALL'
                  rules={[{ required: true, message: "กรุณาเลือกเขต" }]}
                >
                  <Row gutter={8} align='middle'>
                    <Col span={8}>
                      <Radio.Group
                        value={selectZone}
                        onChange={(e) => {
                          setSelectZone(e.target.value);
                          if (e.target.value === "ALL") {
                            form.setFieldValue("zone", undefined);
                          }
                        }}
                        style={{ width: "100%" }}
                      >
                        <Space>
                          <Radio value='ALL'>
                            <Texts>ทั้งหมด</Texts>
                          </Radio>
                          <Radio value='CUSTOM'>
                            <Texts>เลือกเขต</Texts>
                          </Radio>
                        </Space>
                      </Radio.Group>
                    </Col>

                    <Col span={16}>
                      <Form.Item
                        name='zone'
                        noStyle
                        rules={[
                          {
                            required: selectZone === "CUSTOM",
                            message: "กรุณาเลือกเขต",
                          },
                        ]}
                      >
                        <Select
                          disabled={selectZone !== "CUSTOM"}
                          placeholder='ระบุเขต'
                          style={{ width: "100%" }}
                          mode='multiple'
                          data={zone}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          )}

          <Row gutter={16}>
            <Col span={12} style={{ marginTop: 18 }}>
              <Text fontSize={16} fontWeight={700}>
                ไฟล์ลายเซ็นต์
              </Text>
              <br />
              <Text fontSize={14} fontWeight={400} color='grayishBlue' fontFamily='Sarabun'>
                โปรดเลือกไฟล์รูปภาพลายเซ็นต์ที่ต้องการ (ขนาดภาพที่แนะนำ 400*140 px, ไฟล์ .PNG)
              </Text>
              <Form.Item name='file'>
                <UploadImageCropper
                  onFileUpload={handleUpload}
                  value={file}
                  accept='image'
                  aspect={1}
                />
              </Form.Item>
            </Col>
          </Row>
        </Top>
        <Bottom>
          <Col span={22}>
            <Text color='Text3' level={6} fontFamily='Sarabun'>
              โปรดตรวจสอบข้อมูลพนักงานก่อนบันทึก
            </Text>
          </Col>
          <Col span={2}>
            <Button
              title='บันทึก'
              onClick={() => {
                setVisible(true);
              }}
            />
          </Col>
        </Bottom>
      </Form>
      <ConfirmModal
        visible={visible}
        loading={loading}
        onConfirm={() => {
          form.submit();
          setVisible(false);
        }}
        onCancel={() => {
          setVisible(false);
        }}
        title='ยืนยันการบันทึกข้อมูล'
        desc='โปรดยืนยันการบันทึกข้อมูลเพิ่มตำแหน่งชื่อ'
      />
      <ConfirmModal
        visible={visibleWarning}
        onConfirm={() => {
          setVisibleWarning(false);
          navigate(-1);
        }}
        onCancel={() => {
          setVisibleWarning(false);
        }}
        title='คุณต้องการกลับสู่หน้าหลักใช่หรือไม่'
        desc='โปรดยืนยันการกลับสู่หน้าหลัก'
      />
    </CardContainer>
  );
}
